import { MESSAGE_TYPES } from './constants';
import { normalizeHunyuanTranslationLanguage } from 'dashboard/constants/translationLanguages';

const toUnixSeconds = timestamp => {
  const numeric = Number(timestamp);
  if (!Number.isFinite(numeric)) {
    return null;
  }

  // Support both milliseconds and seconds timestamps.
  return numeric > 1_000_000_000_000
    ? Math.floor(numeric / 1000)
    : Math.floor(numeric);
};

const isoToUnixSeconds = isoTimestamp => {
  if (!isoTimestamp) {
    return null;
  }

  const milliseconds = Date.parse(isoTimestamp);
  if (!Number.isFinite(milliseconds)) {
    return null;
  }

  return Math.floor(milliseconds / 1000);
};

export const normalizeTranslationLanguage = languageCode => {
  return normalizeHunyuanTranslationLanguage(languageCode);
};

export const resolveAutoTranslateTargetLanguage = ({
  preferenceTargetLanguage,
  locale,
}) => {
  const shouldFollowUi = preferenceTargetLanguage === 'follow_ui';
  const languageSource = shouldFollowUi ? locale : preferenceTargetLanguage;

  return normalizeTranslationLanguage(languageSource);
};

const extractTranslations = contentAttributes => {
  const attributes = contentAttributes || {};

  return attributes.translations || attributes.Translations || {};
};

export const shouldAutoTranslateIncomingMessage = ({
  messageType,
  isPrivate,
  content,
  contentAttributes,
  createdAt,
  preferences,
  targetLanguage,
}) => {
  if (messageType !== MESSAGE_TYPES.INCOMING) {
    return { shouldTranslate: false, targetLanguage };
  }

  if (isPrivate || contentAttributes?.deleted) {
    return { shouldTranslate: false, targetLanguage };
  }

  if (!content || !content.toString().trim()) {
    return { shouldTranslate: false, targetLanguage };
  }

  if (
    !preferences?.translation_enabled ||
    !preferences?.auto_translate_enabled
  ) {
    return { shouldTranslate: false, targetLanguage };
  }

  if (!targetLanguage) {
    return { shouldTranslate: false, targetLanguage };
  }

  const translations = extractTranslations(contentAttributes);
  if (translations[targetLanguage]) {
    return { shouldTranslate: false, targetLanguage };
  }

  const messageCreatedAt = toUnixSeconds(createdAt);
  const activatedAt = isoToUnixSeconds(preferences.auto_translate_activated_at);
  if (!messageCreatedAt || !activatedAt || messageCreatedAt <= activatedAt) {
    return { shouldTranslate: false, targetLanguage };
  }

  return {
    shouldTranslate: true,
    targetLanguage,
  };
};
